import {Routes, RouterModule} from '@angular/router';
import {PrivacyStatementComponent} from './privacy-statement.component';

const routes:Routes = [
  {
    path: 'privacy_statement',
    component : PrivacyStatementComponent
  }];

export const routing = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/privacy-statement/privacy-statement.routing.ts